import { render, staticRenderFns } from "./CompanyCardSettings.vue?vue&type=template&id=4999bc69&scoped=true&"
import script from "./CompanyCardSettings.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999bc69",
  null
  
)

export default component.exports